import {Chip} from '@dropbox/dig-components/chip';
import {UIIcon} from '@dropbox/dig-icons';
import {AddLine, ChevronUpLine} from '@dropbox/dig-icons/assets';
import {t} from 'i18next';
import {type ComponentPropsWithoutRef, forwardRef} from 'react';

type WorkstreamRoadmapChipProps = Omit<
  ComponentPropsWithoutRef<typeof Chip>,
  'children' | 'size' | 'variant' | 'onDelete'
> & {
  showAddIcon?: boolean;
  isExpanded?: boolean;
};

export const WorkstreamRoadmapChip = forwardRef<HTMLButtonElement, WorkstreamRoadmapChipProps>(
  ({showAddIcon = false, isExpanded = false, withDropdownIcon = true, ...props}, ref) => (
    <Chip
      {...props}
      ref={ref}
      type="button"
      size="small"
      variant="standard"
      withDropdownIcon={withDropdownIcon && !isExpanded}
    >
      {showAddIcon && (
        <Chip.IconAccessory>
          <UIIcon src={AddLine} />
        </Chip.IconAccessory>
      )}
      <Chip.Content>{t('roadmap')}</Chip.Content>
      {isExpanded && (
        <Chip.IconAccessory>
          <UIIcon src={ChevronUpLine} />
        </Chip.IconAccessory>
      )}
    </Chip>
  )
);
WorkstreamRoadmapChip.displayName = 'WorkstreamRoadmapChip';
